module.exports = __webpack_public_path__ + "media/images/product/m_b-663e3491981753c2f76700e315672430.png";